import { getWsUrl } from '$logic/twaCommunication/twaCommiunication.state'
import {
  TWA_EVENTS,
  TwaEvent,
} from '$logic/twaCommunication/twaCommunication.types'
import { isAndroidApp } from '$func/environmentInfo'
import {
  handleAndroidMessage,
  sendEventToTwa,
} from '$logic/twaCommunication/twaCommunication.api'
import { TWA_API_SUPPORT } from '$logic/twaCommunication/constant'

let wsPromise: Promise<WebSocket> | undefined

type Resolve = (value: unknown) => void
type Reject = (reason?: any) => void

export const getTwaPool = (() => {
  const pool: Record<
    string,
    { request: TwaEvent; resolve: Resolve; reject: Reject; timer: NodeJS.Timer }
  > = {}

  return {
    add: (
      reqId: string,
      request: TwaEvent,
      resolve: Resolve,
      reject: Reject,
      timer: NodeJS.Timer,
    ) => {
      console.log('adding to pool ', reqId)
      pool[reqId] = { request, resolve, reject, timer }
    },

    get: (reqId: string) => pool[reqId],
    getAll: () => pool,

    resolve: (reqId: string, response: TwaEvent) => {
      const val = pool[reqId]
      if (val) {
        if (val.timer) clearTimeout(val.timer)
        val.resolve(response.payload)
        delete pool[reqId]
      }
    },

    onTimeout: (uuid: string) => {
      pool[uuid].reject(Error('Timeout'))
      delete pool[uuid]
    },

    resetTimers: () => {
      Object.keys(pool).forEach(key => {
        const { reject, timer } = pool[key]
        if (timer) {
          clearTimeout(timer)
          reject(Error('Reset'))
          delete pool[key]
        }
      })
    },
  }
})()

export const resolveTwaPoolAction = (
  reqId: string,
  action: { type: any; payload: Record<string, string> },
) => getTwaPool.resolve(reqId, action)

const createWebSocket = () => {
  const wsUrl = getWsUrl()
  if (!wsUrl) throw Error('no-ws-url')

  const socket = new WebSocket(wsUrl)
  return new Promise((resolve, reject) => {
    socket.addEventListener('open', resolve)
    socket.addEventListener('error', reject, { once: true })
    socket.addEventListener(
      'error',
      console.log.bind(null, 'TWA WebSocket error:'),
    )
    socket.addEventListener('message', handleAndroidMessage)
  }).then(() => socket)
}

export const createWebsocketForConnectionToTwa = async () => {
  if (!getWsUrl()) return undefined
  if (!wsPromise) wsPromise = createWebSocket()
  try {
    const ws = await wsPromise
    if (
      ws.readyState === WebSocket.CLOSED ||
      ws.readyState === WebSocket.CLOSING
    ) {
      wsPromise = undefined
      return undefined
    }
    return ws
  } catch (e) {
    wsPromise = undefined
    return undefined
  }
}

let ackTimeout: NodeJS.Timeout
const PONG_TIMEOUT = 1000
const checkConnection = () => {
  sendEventToTwa(TWA_EVENTS.PING).then(handleAndroidPong)
  ackTimeout = setTimeout(() => {
    wsPromise = undefined
    wsPromise = createWebSocket()
  }, PONG_TIMEOUT)
}

export const handleAndroidPong = () => {
  clearTimeout(ackTimeout)
}

const RECHECK_TIMEOUT = 3000
export const checkConnectionWithTWA = () => {
  if (!isAndroidApp || !TWA_API_SUPPORT.RECONNECT_WEBSOCKET) return
  setInterval(() => {
    checkConnection()
  }, RECHECK_TIMEOUT)
}
